import { Component, Emitter } from '@wonderlandengine/api';

export class TimeManager extends Component {
    static TypeName = 'time-manager';

    // Singleton
    private static _instance: TimeManager;
    static get instance(): TimeManager {
        return TimeManager._instance;
    }

    private _time: number = 0;
    /**
     * Current time in seconds since the start of the scene.
     * Time update is paused when the scene is paused.
     */
    get time(): number {
        return this._time;
    }

    paused = false;

    onPaused = new Emitter();
    onResumed = new Emitter();

    init() {
        if (TimeManager._instance) {
            console.error(
                'There can only be one instance of TimeManager Component'
            );
        }
        TimeManager._instance = this;
    }

    update(delta: number): void {
        if (!this.paused) {
            this._time += delta;
        }
    }

    stopTime() {
        this.paused = true;
        this.onPaused.notify();
    }

    resumeTime() {
        this.paused = false;
        this.onResumed.notify();
    }
}
